// frontend/src/components/layouts/DefaultLayout.tsx
import { Container } from '@chakra-ui/react'
import Wave from 'react-wavify'
import { useEffect } from 'react'
import Web3 from 'web3'
import { useRecoilState } from 'recoil'
import { useNavigate, useLocation } from 'react-router-dom' // ✅ 추가
import { authState } from '../../atoms/auth'
import Header from './Header'
import Footer from './Footer'
import ScrollToTop from '../ScrollToTop'
import { useAuthState } from '../../utils/authUtils'
import {
  getPartnerFromURL,
  sanitizePartner,
  savePartner
} from '../../utils/referral' // ✅ 추가

interface DefaultLayoutProps {
  children: React.ReactNode
  showHamburgerMenu?: boolean
}

const DefaultLayout = ({
  children,
  showHamburgerMenu = true
}: DefaultLayoutProps) => {
  const navigate = useNavigate()
  const location = useLocation() // ✅ 추가
  const [auth, setAuth] = useRecoilState(authState)
  const { reloadUser } = useAuthState()

  // 로그인 정보 리로드
  useEffect(() => {
    try {
      reloadUser()
    } catch (err) {
      //
    }
  }, [])

  // ✅ 파트너 코드 캡처 (홈/로그인/회원가입 어디서든)
  useEffect(() => {
    const raw = getPartnerFromURL(location.search)
    const partner = sanitizePartner(raw)
    if (partner) {
      savePartner(partner)
    }
  }, [location.search])

  return (
    <>
      <ScrollToTop />
      <Header />
      {children}
      <Footer />
    </>
  )
}

export default DefaultLayout
